module.exports = __webpack_public_path__ + "media/application/images/svgs/slack-300e153783d7dd8de750b5418c4205f6.svg";